import { render, staticRenderFns } from "./SelectUnitBackup.vue?vue&type=template&id=3ab46947&"
import script from "./SelectUnitBackup.vue?vue&type=script&lang=ts&"
export * from "./SelectUnitBackup.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/agent/workspace/SPP/deployment/frontend-erp-spp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3ab46947')) {
      api.createRecord('3ab46947', component.options)
    } else {
      api.reload('3ab46947', component.options)
    }
    module.hot.accept("./SelectUnitBackup.vue?vue&type=template&id=3ab46947&", function () {
      api.rerender('3ab46947', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/custom/select/SelectUnitBackup.vue"
export default component.exports